export default {
  name: 'marking--erpGoods',
  apiService: 'shoes',
  apiPath: '/admin/doc_erp_goods',
};